import angular from 'angular';

import AccessControlService from './AccessControlService';
import GatesService from './GatesService';
import GenetecService from './GenetecService';
import PumpsService from './PumpsService';
import DialPanelComponent from './DialPanelComponent';
import DialOptionsComponent from './DialOptionsComponent';

export default angular
  .module('petroCloud.dashboard.dialPanel', [])
  .service('AccessControlService', AccessControlService)
  .service('GatesService', GatesService)
  .service('GenetecService', GenetecService)
  .service('PumpsService', PumpsService)
  .component(DialPanelComponent.name, DialPanelComponent)
  .component(DialOptionsComponent.name, DialOptionsComponent)
  .name;
